const menuItems = [
  {
    title: 'Koti',
    icon: 'HomeIcon',
    route: 'apps-dashboard-home',
    resource: 'Dashboard',
    action: 'read',
  },
  {
    title: 'Tilastot',
    icon: 'BarChart2Icon',
    route: 'apps-dashboard-analytics',
    resource: 'Dashboard',
    action: 'read',
  },
]
export default {menuItems}